import { Stack } from '@mantine/core';
import type { EntityPolicyOut } from '@repo/api-codegen';
import { Text, Title } from '@repo/foundations';
import { useMemo } from 'react';
import { SelectorRender } from '../../components/TableV2/render';
import type { ExtendedDataTableColumn } from '../../components/TableV2/types';
import { FrameworkSelector } from '../../pages/PoliciesPage/components/FrameworkSelector';
import {
	PolicyIssueStatus,
	PolicyOKStatus,
} from '../../pages/PoliciesPage/render';

export function useColumns(): ExtendedDataTableColumn<EntityPolicyOut>[] {
	const columns: ExtendedDataTableColumn<EntityPolicyOut>[] = useMemo(
		() => [
			{
				accessor: 'name',
				titleLabel: 'Policies',
				render: (record) => (
					<Stack role="link" spacing={0} py="xs">
						<Title size="sm" truncate>
							{record.name}
						</Title>
						<Text size="xs" color="text/secondary/default" truncate>
							{record.description}
						</Text>
					</Stack>
				),
				width: 'auto',
			},
			{
				accessor: 'severity',
				titleLabel: 'Severity',
				navigate: false,
				render: (record) => (
					<SelectorRender
						key="severity"
						accessor="severity"
						nilOption="NONE"
						onChange={undefined}
						record={record}
					/>
				),
				width: 100,
			},
			{
				accessor: 'status',
				titleLabel: 'Status',
				navigate: false,
				render: (record) => {
					if (record.violating) {
						return <PolicyIssueStatus />;
					}
					return <PolicyOKStatus />;
				},
				width: 200,
			},
			{
				accessor: 'frameworks',
				titleLabel: 'Frameworks',
				navigate: false,
				render: (record) => <FrameworkSelector policy={record} readOnly />,
				width: 150,
			},
		],
		[]
	);

	return columns;
}
